module.exports = __webpack_public_path__ + "static/media/logo.f28fa72c.svg";